import listActions from 'src/modules/benchmarkStudy/list/benchmarkStudyListActions';
import BenchmarkStudyService from 'src/modules/benchmarkStudy/benchmarkStudyService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'BENCHMARKSTUDY_DESTROY';

const benchmarkStudyDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: benchmarkStudyDestroyActions.DESTROY_STARTED,
      });

      await BenchmarkStudyService.destroyAll([id]);

      dispatch({
        type: benchmarkStudyDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.benchmarkStudy.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/benchmark-study');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: benchmarkStudyDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: benchmarkStudyDestroyActions.DESTROY_ALL_STARTED,
      });

      await BenchmarkStudyService.destroyAll(ids);

      dispatch({
        type: benchmarkStudyDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.benchmarkStudy.destroyAll.success'),
      );

      getHistory().push('/benchmark-study');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: benchmarkStudyDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default benchmarkStudyDestroyActions;
